var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomDateSecondaryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9228",
    "data-name": "Group 9228",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.023,
    height: 29.854,
    viewBox: "0 0 30.023 29.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M4174.977,261.412c0,.369,0,.712,0,1.057,0,.6,0,1.2.009,1.8a1.86,1.86,0,0,0,1.38,1.731,1.9,1.9,0,0,0,2.045-.688,1.946,1.946,0,0,0,.377-1.181c0-.872,0-1.744,0-2.614,0-.029,0-.056,0-.093h14.548v.439c0,.786-.008,1.573.006,2.359a1.906,1.906,0,0,0,3.546.919,1.781,1.781,0,0,0,.258-.974c-.009-.455,0-.91,0-1.363v-1.392h.544c.806,0,1.612,0,2.415.005a.927.927,0,0,1,.969.989q0,3.055,0,6.109v11.038q0,3.778,0,7.558a3.4,3.4,0,0,1-.013.424.923.923,0,0,1-.924.8c-.891,0-1.781,0-2.672,0h-11.252l-4.19,0-7.374,0c-.877,0-1.754-.016-2.628.005a1,1,0,0,1-.969-.974c.014-2.281.006-4.564.006-6.848q0-4.638,0-9.276c0-1.339,0-2.68,0-4.02q0-2.416,0-4.83a.914.914,0,0,1,.973-.978c.928,0,1.855,0,2.785,0Zm11.058,25.68h.212l4.122.007c.936,0,1.874,0,2.811,0,1.059,0,2.112-.007,3.169-.007.856,0,1.714.007,2.573.007a.852.852,0,0,0,.925-.928v-3.764q0-3.511,0-7.018,0-3.425,0-6.848a.866.866,0,0,0-.951-.951c-.933,0-1.867.005-2.8,0q-2.763,0-5.525-.009c-.929,0-1.857.009-2.787.009q-3.22,0-6.447-.009c-.794,0-1.592.009-2.386.009q-2.878,0-5.756,0a.85.85,0,0,0-.905.906c0,.913,0,1.827,0,2.742q0,3.522,0,7.045,0,3.937,0,7.871a.836.836,0,0,0,.917.931c1.4,0,2.8,0,4.2,0l3.835.007c.686,0,1.374-.005,2.061-.007Z",
    transform: "translate(-4171.052 -258.487)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M4183.879,263.238c0-.751,0-1.5,0-2.256a1.108,1.108,0,0,1,.589-1.044,1.074,1.074,0,0,1,1.193.061,1.055,1.055,0,0,1,.479.9q0,1.8-.008,3.592c0,.372.017.748-.019,1.118a1.105,1.105,0,0,1-1.045.938,1.125,1.125,0,0,1-1.112-.737,1.472,1.472,0,0,1-.067-.4c-.005-.725,0-1.449,0-2.174Z",
    transform: "translate(-4160.813 -259.785)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M4175.915,263.115c0,.809.012,1.62-.006,2.429a1.1,1.1,0,0,1-.888.98,1.133,1.133,0,0,1-1.208-.545,1.2,1.2,0,0,1-.146-.6c0-1.472,0-2.943,0-4.415a1.132,1.132,0,0,1,1.073-1.172,1.112,1.112,0,0,1,1.18,1.079c.005.748,0,1.5,0,2.244Z",
    transform: "translate(-4168.968 -259.783)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M4181.529,273.153c0-.59-.009-1.179,0-1.767.011-.631.265-.935.873-.947q1.857-.038,3.711,0a.818.818,0,0,1,.862.91q.019,1.8,0,3.594a.859.859,0,0,1-.914.938c-1.2.023-2.4.022-3.595,0a.855.855,0,0,1-.937-.964C4181.52,274.331,4181.529,273.741,4181.529,273.153Z",
    transform: "translate(-4162.694 -251.302)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M4174.056,269.356c0-.57-.01-1.138,0-1.708.012-.613.29-.938.875-.947q1.857-.032,3.709,0a.806.806,0,0,1,.857.908q.017,1.793,0,3.59a.835.835,0,0,1-.9.935c-1.217.025-2.436.027-3.651,0-.594-.013-.877-.347-.887-.949S4174.056,269.964,4174.056,269.356Z",
    transform: "translate(-4168.654 -254.281)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M4180.507,266.688c.57,0,1.14-.009,1.708,0,.691.014,1.016.324,1.022,1q.018,1.734,0,3.471a.874.874,0,0,1-.94.973q-1.794.032-3.591,0c-.622-.013-.91-.34-.915-.982q-.017-1.764,0-3.531a.809.809,0,0,1,.893-.928c.607-.022,1.216,0,1.822,0Z",
    transform: "translate(-4165.678 -254.281)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M4174.058,273.1c0-.59-.011-1.179,0-1.767a.813.813,0,0,1,.87-.9q1.856-.035,3.714,0a.8.8,0,0,1,.855.906q.018,1.8,0,3.6a.844.844,0,0,1-.9.94q-1.827.038-3.652,0a.844.844,0,0,1-.889-.951C4174.048,274.321,4174.058,273.711,4174.058,273.1Z",
    transform: "translate(-4168.659 -251.302)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M4183.245,273.133c0,.59.009,1.179,0,1.769-.01.633-.3.969-.921.982-1.2.023-2.4.021-3.593,0a.862.862,0,0,1-.93-.974c-.007-1.179-.009-2.357,0-3.536a.823.823,0,0,1,.89-.938q1.827-.035,3.652,0c.6.011.884.324.9.929C4183.255,271.955,4183.245,272.545,4183.245,273.133Z",
    transform: "translate(-4165.67 -251.303)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M4184.28,266.689c.57,0,1.14-.011,1.707,0,.664.016.987.325.991.969q.021,1.766,0,3.531a.853.853,0,0,1-.91.94q-1.822.038-3.649,0c-.592-.013-.879-.342-.886-.947q-.017-1.8,0-3.59a.8.8,0,0,1,.863-.9c.627-.025,1.255-.007,1.882-.007Zm1.611,1.089h-3.259v3.261h3.259Z",
    transform: "translate(-4162.692 -254.281)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDateSecondaryIcon);
export default __webpack_public_path__ + "static/media/CustomDateSecondaryIcon.80573e5d71813def7b60b5f655532730.svg";
export { ForwardRef as ReactComponent };